/* eslint-disable */
<template lang="html">
  <div style="margin-bottom: 300px">
    <div
      class="display-1 
                d-flex 
                justify-center 
                text-center
                mt-12
                pt-4
                grey--text 
                text--darken-2
                "
      v-text="name"
    ></div>
    <v-container class="my-5">
      <v-layout row>
        <v-card
          class="mx-auto 
                  mb-4
                  mt-2"
          max-width="344"
          v-for="(product, index) in products"
          :key="index"
        >
          <v-img v-bind:src="product.prodImgUrl" height="200px"></v-img>

          <v-card-title style="word-break: normal;" class="text-center">
            <span style="margin: 0 auto" v-text="product.prodName"> </span>
          </v-card-title>
        </v-card>
        <!-- ssss -->
      </v-layout>
    </v-container>
  </div>
</template>
<script>
export default {
  data: () => ({
    name: "SASH Master-ის ზეთები ",
    text: "This is product",
    show: false,
    alignmentsAvailable: ["start", "center", "end", "baseline", "stretch"],
    alignment: "center",
    dense: false,
    justifyAvailable: [
      "start",
      "center",
      "end",
      "space-around",
      "space-between"
    ],
    justify: "center",
    products: [
      {
        prodName: "MASTER PLUS SHPD E2 SAE 15W-40, 200ლ, 20ლ",
        specification:
          "ACEA A2/B2/B4-02 & E2-07, API: CH-4/CF IVECO-PEGASO, MB 228.1, CAT TO-2, MAN M271 MACK EO-L Plus Volvo VDS",
        prodImgUrl:
          "https://i2.wp.com/www.lubricantes-sash.com/wp-content/uploads/2018/03/MASTER_PLUS_SHPD_15W40.png?zoom=1.25&w=930&ssl=1"
      },
      {
        prodName: "MASTER ULTRA THPD E7 SAE 15W-40, 200ლ",
        specification:
          "API: SN/CI-4/CH-4/CF, ACEA A3/B3/B4 & E7, MAN M3275, IVECO-PEGASO, DAF XF, Renault RLD-2, MB 229.1, 228.3, Scania LDF, Volvo VDS-3.",
        prodImgUrl:
          "https://i0.wp.com/www.lubricantes-sash.com/wp-content/uploads/2018/03/MASTER_ULTRA_THPD_E7_15W40.png?zoom=1.25&w=930&ssl=1"
      },
      {
        prodName: "MASTER OEM HD E7 SAE 15W40, 200ლ",
        specification: "API: CI-4/SL, ACEA E7",
        prodImgUrl:
          "https://i2.wp.com/www.lubricantes-sash.com/wp-content/uploads/2018/03/MASTER_OEM_HD_E7_15W40.png?zoom=1.25&w=930&ssl=1"
      }
    ]
  })
};
</script>
